import React, { useState } from "react";
import { useParams, redirect, useNavigate } from "react-router-dom";
import axios from "axios";
import '../../App.css';

const PasswordReset = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  let navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }
    axios.post("https://mygamename.com/php/update_password.php", {
      token: token,
      password: password,
    }).then((response) => {
        if (response.data == 'Password updated successfully.') {
          //"Password updated successfully."
          navigate('/login');
          console.log(response);
        } else {
          //navigate('/create');
          console.log(response);
        }
    });
  };

  return (
    <div className="flex justify-center items-center h-screen">
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded-md">
      <h1 className="mb-4 text-4xl font-extrabold leading-none tracking-tight text-gray-900 md:text-5xl lg:text-6xl dark:text-white">Password Reset</h1>
                <input
                type="password"
                placeholder="Enter new password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                required
                />
                <input
                type="password"
                placeholder="Confirm new password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-[2em] focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                required
                />
                <button
                type="submit"
                className="w-full bg-blue-500 text-white py-2 rounded-md hover:bg-blue-600"
                >
                Reset Password
                </button>
                {message && <p className="mt-4 text-center text-gray-700">{message}</p>}
            </form>
    </div>
  );
};

export default PasswordReset;
